import type { AgencyStructureNode } from '@gat-ship/types'

/**
 * Default agency-node selection for the agency-settings panel. Agency settings
 * are agency-scoped, so prefer the first agency node over a leading group, and
 * fall back to the first node otherwise.
 *
 * Returns the next nodeId to select, or `null` to leave the current selection
 * as-is — i.e. when the structure is empty, or the current `nodeId` is still
 * present in the fetched structure.
 */
export function pickDefaultAgencyNode(
  structure: readonly AgencyStructureNode[],
  currentNodeId: string
): string | null {
  const first =
    structure.find((node) => node.$type === 'agency') ?? structure[0]
  if (!first) return null
  if (structure.some((node) => node.id === currentNodeId)) return null
  return first.id
}
